import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CasePaymentInformation.module.scss'
import { paymentAmountAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const PaymentAmount = ({
  t,
  i18n,
  selectedOption,
  setSelectedOption,
  selectedOptionValid,
  setSelectedOptionValid,
  validatePaymentAmount,
  paymentAmountErrorPart1,
  paymentAmountErrorNumber,
  paymentAmountErrorPart2,
  paymentAmountValid,
  setPaymentAmountValid,
  setIsError,
}) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const { minPaymentAmount, paymentAmount } = useSelector((state) => state.app)

  const amountOwing = useSelector((state) => state.app.amountOwing)

  const onOptionChange = (e) => {
    let option = e.currentTarget.value
    setSelectedOptionValid(true)
    setSelectedOption(option)
    setPaymentAmountValid(true)
    dispatch(paymentAmountAction(option === 'full' ? amountOwing : ''))
  }

  const handlePaymentAmount = (e) => {
    try {
      let amount = e.currentTarget.value
      amount = amount.split(',').join('.')
      dispatch(paymentAmountAction(amount))
      if (parseFloat(paymentAmount) <= parseFloat(minPaymentAmount)) {
        validatePaymentAmount(amount)
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  // const onBlurPaymentAmount = (e) => {
  //   try {
  //     let amount = e.currentTarget.value.trim()
  //     SetIsFocussed(false)
  //     amount = amount.split(',').join('.')
  //     dispatch(paymentAmountAction(amount))
  //     validatePaymentAmount(amount)
  //   } catch (err) {
  //     console.log(err)
  //     setIsError(true)
  //   }
  // }

  const handleOnPaste = (e) => {
    e.preventDefault()
    return false
  }

  const getPaymentAmountFr = (amount) => {
    if (amount && i18n.language !== 'en') {
      if (amount.includes('.')) {
        return amount.split('.').join(',')
      }
    }
    return amount
  }

  const paymentOptions = (
    <div>
      <div className="ns-radios__item">
        <input
          className="ns-radios__input"
          type="radio"
          name="paymentAmount"
          value="full"
          id="paymentAmountFull"
          checked={selectedOption === 'full'}
          onChange={onOptionChange}
        />
        <label className="ns-label ns-radios__label" htmlFor="paymentAmountFull">
          <span className="ns-label-span">
            <b>{t('case_payment_information.full_amount')}</b>
          </span>
        </label>
      </div>
      {paymentAmountValid === false && selectedOption === 'full' && (
        <div className="help-block" style={{ marginBottom: '5px', color: '#a94442' }}>
          <i className="fa fa-exclamation-circle" aria-hidden="true" style={{ marginRight: '5px' }}></i>
          {t(paymentAmountErrorPart1)}
          {paymentAmountErrorNumber}
          {t(paymentAmountErrorPart2)}
        </div>
      )}
      <div className="ns-radios__item" style={{ zIndex: 1 }}>
        <input
          className="ns-radios__input"
          type="radio"
          id="paymentAmountPartial"
          name="paymentAmount"
          value="partial"
          checked={selectedOption === 'partial'}
          onChange={onOptionChange}
        />
        <label className="ns-label ns-radios__label" htmlFor="paymentAmountPartial">
          <span className="ns-label-span">
            <b>{t('case_payment_information.partial_amount')}</b>
          </span>
        </label>
      </div>
    </div>
  )

  return (
    <React.Fragment>
      <div className={['form-group', styles['fields_margin']].join(' ')}>
        <strong className="control-label" htmlFor="PaymentAmount">
          {t('case_payment_information.payment_options')}
        </strong>
        <div>
          {t('case_payment_information.you_can_most_restitutions')}
          {t('case_payment_information.government_services_may_be')}{' '}
        </div>
        <br />
        {selectedOptionValid === false ? (
          <div style={{ display: 'flex', gap: '10px' }}>
            <div className={styles['radio_selection_error']}></div>
            <div>
              <label className="has-error" style={{ margin: '-6px 0px 10px 0px' }}>
                <b>{t('case_payment_information.select_option')}</b>
              </label>
              {paymentOptions}
            </div>
          </div>
        ) : (
          paymentOptions
        )}
        {selectedOption === 'partial' && (
          <div className={[paymentAmountValid === false && 'form-group has-error', styles['partial_payment_div']].join(' ')}>
            <div
              className={styles['vertical_line']}
              style={{
                backgroundColor: paymentAmountValid === false ? '#a94442' : '#0058a4',
                height: paymentAmountErrorNumber ? '120px' : paymentAmountValid === false ? '90px' : '65px',
              }}
            ></div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="textbox" style={{ marginBottom: '5px' }}>
                <b>{t('case_payment_information.payment_amount')}</b>
              </label>
              {paymentAmountValid === false && selectedOption === 'partial' && (
                <div className={isFocussed ? 'help-block-focused' : 'help-block'} style={{ marginBottom: '5px' }}>
                  <i className="fa fa-exclamation-circle" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                  {t(paymentAmountErrorPart1)}
                  {paymentAmountErrorNumber}
                  {t(paymentAmountErrorPart2)}
                </div>
              )}
              <div className={styles['input_box_div']}>
                <div className={styles['dollor_icon']}>
                  <span style={{ fontSize: '18px', fontWeight: 'bolder' }}>$</span>
                </div>
                <input
                  autoFocus
                  type="number"
                  id="PaymentAmount"
                  className={['ns-input form-control', styles['field_width']].join(' ')}
                  value={paymentAmount}
                  onChange={handlePaymentAmount}
                  // onBlur={onBlurPaymentAmount}
                  onFocus={() => SetIsFocussed(true)}
                  onKeyDown={(event) => {
                    if (['e', 'E', '+', '-'].includes(event.key)) {
                      event.preventDefault()
                    }
                  }}
                  autoComplete="off"
                  onPaste={handleOnPaste}
                  maxLength="150"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(PaymentAmount)
